import React from 'react';
import { motion } from 'framer-motion';
import { Quote, TrendingUp } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: "Finally, an SEO agency that understands B2B SaaS. They didn't just increase our traffic by 150%; they increased our demo requests by 210%. They speak our language and deliver actual pipeline.",
    author: 'Sarah Jenkins',
    role: 'VP of Marketing, TechFlow Solutions',
    metric: '+210% Demo Requests',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }, {
    quote: 'We were stuck on page 2 for our most lucrative keywords for years. Within 4 months, SEO Company OC had us in the top 3. The ROI has been staggering. Best vendor decision I made this year.',
    author: 'Michael Chen',
    role: 'CMO, Apex Financial',
    metric: 'Top 3 Rankings for Core Terms',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }];
  return <section className="py-24 bg-brand-50 relative overflow-hidden" id="results" data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-198">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4 tracking-tight" data-id="element-199">
            Don't just take our word for it.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600" data-id="element-200">
            Hear from marketing leaders who stopped settling for mediocre SEO.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-201">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-8 md:p-10 shadow-xl shadow-slate-200/40 relative" data-id="element-202">
              <Quote className="absolute top-8 right-8 w-12 h-12 text-brand-100" data-id="element-203" />

              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm font-bold mb-6 border border-green-100" data-id="element-204">
                <TrendingUp className="w-4 h-4" data-id="element-205" />
                {testimonial.metric}
              </div>

              <p className="text-lg text-slate-700 mb-8 relative z-10 font-medium leading-relaxed" data-id="element-206">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-207">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-slate-100" data-id="element-208" />
                <div data-id="element-209">
                  <div className="font-bold text-slate-900" data-id="element-210">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-slate-500" data-id="element-211">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}